import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoHead from '@/components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const companyJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: '대구드레스룸 키친스',
    alternateName: '키친스',
    url: SITE_URL,
    telephone: '053-766-0411',
    faxNumber: '053-766-0412',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '침산남로48',
      addressLocality: '북구',
      addressRegion: '대구광역시',
      addressCountry: 'KR',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 35.8844,
      longitude: 128.5826,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
    ],
    description: '대구 북구 침산동 드레스룸, 붙박이장, 팬트리 전문 시공업체. 수년간의 노하우로 맞춤형 수납 솔루션을 제공합니다.',
    priceRange: '$$',
    areaServed: {
      '@type': 'City',
      name: '대구광역시',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '회사안내 | 대구드레스룸 키친스',
    description: '대구드레스룸 키친스 회사 소개, 드레스룸·붙박이장·팬트리 전문 시공업체 안내.',
    url: `${SITE_URL}/company`,
    inLanguage: 'ko',
  },
];

const features = [
  {
    icon: 'ri-home-heart-line',
    title: '드레스룸 전문 시공',
    desc: '고객의 라이프스타일에 맞춘 맞춤형 드레스룸을 설계하고 시공합니다. 공간 활용을 극대화한 최적의 수납 솔루션을 제공합니다.',
  },
  {
    icon: 'ri-store-2-line',
    title: '팬트리 & 수납장',
    desc: '주방 팬트리부터 다용도 수납장까지, 생활 공간 전반의 수납 문제를 해결해드립니다.',
  },
  {
    icon: 'ri-tools-line',
    title: '수년간의 시공 노하우',
    desc: '오랜 현장 경험을 바탕으로 정확하고 꼼꼼한 시공을 약속드립니다. 고객 만족을 최우선으로 생각합니다.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '고객 중심 서비스',
    desc: '상담부터 시공 완료 후 A/S까지 고객과 함께합니다. 언제나 고객을 먼저 생각하는 대구드레스룸 키친스입니다.',
  },
];

const companyInfo = [
  { label: '상호명', value: '대구드레스룸 키친스' },
  { label: '대표자', value: '신우창' },
  { label: '사업자등록번호', value: '503-17-45896' },
  { label: '주소', value: '대구광역시 북구 침산남로48' },
  { label: '전화번호', value: '053-766-0411' },
  { label: '팩스', value: '053-766-0412' },
];

export default function CompanyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SeoHead
        title="회사안내 | 대구드레스룸 키친스"
        description="대구 북구 침산동 드레스룸 전문업체 키친스. 드레스룸, 붙박이장, 팬트리, 거실장, 신발장 맞춤 시공. 수년간의 노하우로 고객 맞춤 수납 솔루션 제공. 053-766-0411"
        keywords="대구드레스룸, 드레스룸전문업체, 붙박이장시공, 팬트리, 키친스"
        canonical={`${SITE_URL}/company`}
        jsonLd={companyJsonLd}
      />
      <Navbar />

      <main className="flex-1 pt-16">

        {/* Hero — 제품 이미지 그리드 */}
        <section className="w-full">
          <div className="grid grid-cols-2 grid-rows-2 w-full h-[420px] md:h-[520px]">
            <div className="overflow-hidden w-full h-full">
              <img
                src="https://public.readdy.ai/ai/img_res/66bded1b54e5c583652a8fb0892fbe8e.jpg"
                alt="대구드레스룸 키친스 드레스룸 시공 1"
                className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="overflow-hidden w-full h-full">
              <img
                src="https://readdy.ai/api/search-image?query=luxury%20black%20matte%20finish%20dressing%20room%20closet%20with%20dark%20shelves%2C%20gold%20handles%2C%20LED%20lighting%20strips%2C%20premium%20walk-in%20wardrobe%20interior%2C%20modern%20Korean%20apartment%2C%20sophisticated%20design&width=800&height=520&seq=company02&orientation=landscape"
                alt="대구드레스룸 키친스 드레스룸 시공 2"
                className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="overflow-hidden w-full h-full">
              <img
                src="https://readdy.ai/api/search-image?query=kitchen%20pantry%20storage%20cabinet%20with%20white%20shelves%2C%20organized%20food%20storage%2C%20built-in%20pantry%20unit%2C%20clean%20modern%20kitchen%20interior%2C%20bright%20white%20background%2C%20Korean%20home%20renovation&width=800&height=520&seq=company03&orientation=landscape"
                alt="대구드레스룸 키친스 팬트리 시공 3"
                className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="overflow-hidden w-full h-full">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20wood%20tone%20walk-in%20closet%20with%20warm%20lighting%2C%20natural%20wood%20finish%20shelves%2C%20organized%20clothing%20storage%2C%20cozy%20dressing%20room%20interior%2C%20modern%20Korean%20home%2C%20warm%20ambient%20light&width=800&height=520&seq=company04&orientation=landscape"
                alt="대구드레스룸 키친스 드레스룸 시공 4"
                className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
              />
            </div>
          </div>
        </section>

        {/* 인사말 */}
        <section className="max-w-6xl mx-auto px-6 py-16 flex flex-col lg:flex-row gap-12 items-center">
          <div className="flex-1">
            <p className="text-xs font-semibold tracking-widest text-yellow-600 uppercase mb-3">About Us</p>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-yellow-400 flex-shrink-0">
                <i className="ri-home-heart-line text-white text-2xl" />
              </div>
              <span className="text-base font-bold text-gray-700 leading-tight">
                대구드레스룸 <span className="text-yellow-500">키친스</span>
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-snug mb-6">
              안녕하세요.<br />대구드레스룸 키친스입니다.
            </h2>
            <p className="text-gray-600 leading-relaxed text-sm md:text-base">
              저희 대구드레스룸 키친스는 <strong className="text-gray-800">드레스룸/팬트리를 취급하는 전문업체</strong>이며
              수년간의 노하우로 여러분을 모시겠습니다.
            </p>
            <p className="text-gray-600 leading-relaxed text-sm md:text-base mt-3">
              항상 고객님들에게 최상의 제품으로 안내하겠습니다.<br />
              언제나 고객을 먼저 생각하겠습니다. 감사합니다.
            </p>
          </div>

          {/* 전화 CTA */}
          <div className="flex-shrink-0 w-full lg:w-72 bg-yellow-50 rounded-xl p-8 flex flex-col items-center gap-4 border border-yellow-100">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-yellow-400">
              <i className="ri-phone-line text-white text-2xl" />
            </div>
            <p className="text-sm text-gray-500 font-medium">전화 상담 문의</p>
            <a
              href="tel:053-766-0411"
              className="text-2xl font-bold text-gray-900 tracking-wide hover:text-yellow-600 transition-colors whitespace-nowrap"
            >
              053.766.0411
            </a>
            <p className="text-xs text-gray-400 text-center">
              평일 09:00 ~ 18:00<br />토·일·공휴일 휴무
            </p>
          </div>
        </section>

        {/* 주요 특징 */}
        <section className="bg-gray-50 py-16">
          <div className="max-w-6xl mx-auto px-6">
            <p className="text-xs font-semibold tracking-widest text-yellow-600 uppercase mb-3 text-center">Why Us</p>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 text-center mb-10">
              대구드레스룸 키친스를 선택하는 이유
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="bg-white rounded-xl p-6 flex flex-col gap-4 border border-gray-100 hover:border-yellow-300 transition-colors"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-yellow-50">
                    <i className={`${f.icon} text-yellow-500 text-xl`} />
                  </div>
                  <h4 className="text-sm font-semibold text-gray-800">{f.title}</h4>
                  <p className="text-xs text-gray-500 leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 회사 정보 */}
        <section className="max-w-6xl mx-auto px-6 py-16">
          <p className="text-xs font-semibold tracking-widest text-yellow-600 uppercase mb-3">Company Info</p>
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-8">회사 정보</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 border border-gray-200 rounded-xl overflow-hidden">
            {companyInfo.map((item, idx) => (
              <div
                key={item.label}
                className={`flex items-start gap-4 px-6 py-4 ${
                  idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'
                } border-b border-gray-100 last:border-b-0`}
              >
                <span className="text-xs font-semibold text-gray-400 w-28 flex-shrink-0 pt-0.5">{item.label}</span>
                <span className="text-sm text-gray-800 font-medium">{item.value}</span>
              </div>
            ))}
          </div>
        </section>

        {/* 오시는 길 */}
        <section className="bg-gray-50 py-16">
          <div className="max-w-6xl mx-auto px-6">
            <p className="text-xs font-semibold tracking-widest text-yellow-600 uppercase mb-3">Location</p>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">오시는 길</h3>
            <p className="text-sm text-gray-500 mb-8">대구광역시 북구 침산남로48</p>

            <div className="w-full rounded-xl overflow-hidden border border-gray-200 h-[400px] md:h-[480px]">
              <iframe
                title="대구드레스룸 키친스 오시는 길"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                src="https://maps.google.com/maps?q=대구광역시+북구+침산남로48&t=m&z=16&output=embed&iwloc=near"
              />
            </div>

            <div className="mt-6 flex flex-col sm:flex-row gap-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-yellow-100 flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-yellow-600 text-sm" />
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 mb-0.5">주소</p>
                  <p className="text-sm text-gray-800">대구광역시 북구 침산남로48</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-yellow-100 flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-yellow-600 text-sm" />
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 mb-0.5">전화</p>
                  <a href="tel:053-766-0411" className="text-sm text-gray-800 hover:text-yellow-600 transition-colors">053-766-0411</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-yellow-100 flex-shrink-0 mt-0.5">
                  <i className="ri-printer-line text-yellow-600 text-sm" />
                </div>
                <div>
                  <p className="text-xs font-semibold text-gray-500 mb-0.5">팩스</p>
                  <p className="text-sm text-gray-800">053-766-0412</p>
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
}
